<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs10 offset-xs1>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      label="Training Category Name"
                      v-model="formSchema.name"
                      :rules="[(v) => !!v || 'Field is required']"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md2> </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-checkbox
                      v-model="formSchema.active"
                      label="Active"
                      :value="isActiveVal"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                @click.native="validateBeforeSubmit"
                :disabled="!valid"
                >{{ buttonTitle }}</v-btn
              >
              <v-btn color="error" @click.native="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    roleList: [],
    isActiveVal: 1,
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Update Training Category"
        : "Training Category";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    },
  },

  created() {
    let root = this;
    commonService.getAllData("get-role-list").then((res) => {
      root.roleList = res.roleList;
    });
  },

  methods: {
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;

      var root = this;
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "category")
            .then((res) => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status,
              };
              this.close(actionData);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "category")
            .then((res) => {
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status,
              };
              this.close(actionData);
            });
        }
      }
    },

    close: function(message) {
      if (message.status == 1) {
        this.$refs.form.reset();
      }
      this.$emit("emitCloseModal", message);
    },
    reset() {
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },
  },
  watch:{
	  formSchema(){
		//   console.log(this.formSchema)
	  }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/training/training_category/training_form.vue